module.exports = __webpack_public_path__ + "img/platinum.3c07249.webp";